(function (global) {
  "use strict";

  var STORAGE_PREFIX = "p4p-hand-orders-";

  function getActiveStep(totalOrders) {
    var orders = Number(totalOrders);
    if (!Number.isFinite(orders) || orders < 0) orders = 0;
    return (orders % 5) + 1;
  }

  function readTotalOrders(root) {
    var raw = root.getAttribute("data-total-orders");
    var parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
  }

  function writeTotalOrders(root, value) {
    root.setAttribute("data-total-orders", String(value));
  }

  function updateStepStates(root, activeStep) {
    root.querySelectorAll("[data-hand-step]").forEach(function (step) {
      var stepNumber = parseInt(step.getAttribute("data-hand-step"), 10);
      var isComplete = stepNumber <= activeStep;
      step.classList.toggle("is-complete", isComplete);
      step.classList.toggle("is-locked", !isComplete);
      step.setAttribute("aria-current", stepNumber === activeStep ? "step" : "false");
    });

    var statusNode = root.querySelector("[data-hand-status-count]");
    if (statusNode) statusNode.textContent = String(activeStep);
  }

  function render(root) {
    var totalOrders = readTotalOrders(root);
    var activeStep = getActiveStep(totalOrders);
    updateStepStates(root, activeStep);
    root.setAttribute("data-active-step", String(activeStep));
  }

  function HandProductionProgress(root) {
    this.root = root;
    this.productId = root.getAttribute("data-product-id") || "global";
    this.incrementOnCart =
      root.getAttribute("data-increment-on-cart") === "true";

    if (this.incrementOnCart) {
      var stored = localStorage.getItem(STORAGE_PREFIX + this.productId);
      if (stored !== null) {
        var storedValue = parseInt(stored, 10);
        if (Number.isFinite(storedValue) && storedValue >= 0) {
          writeTotalOrders(root, storedValue);
        }
      }
    }

    this.boundCartHandler = this.handleCartUpdated.bind(this);
    render(root);
  }

  HandProductionProgress.prototype.persist = function () {
    if (!this.incrementOnCart) return;
    localStorage.setItem(
      STORAGE_PREFIX + this.productId,
      String(readTotalOrders(this.root)),
    );
  };

  HandProductionProgress.prototype.handleCartUpdated = function () {
    if (!this.incrementOnCart) return;
    var next = readTotalOrders(this.root) + 1;
    writeTotalOrders(this.root, next);
    this.persist();
    render(this.root);
  };

  HandProductionProgress.prototype.setTotalOrders = function (value) {
    writeTotalOrders(this.root, Math.max(0, Number(value) || 0));
    this.persist();
    render(this.root);
  };

  HandProductionProgress.prototype.bind = function () {
    if (this.incrementOnCart) {
      document.addEventListener("p4p:cart:updated", this.boundCartHandler);
    }
  };

  HandProductionProgress.prototype.destroy = function () {
    document.removeEventListener("p4p:cart:updated", this.boundCartHandler);
  };

  function initAll() {
    document.querySelectorAll("[data-hand-production]").forEach(function (root) {
      if (root.__handProduction) return;
      var instance = new HandProductionProgress(root);
      instance.bind();
      root.__handProduction = instance;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);

  global.P4PHandProduction = {
    init: initAll,
    getActiveStep: getActiveStep,
  };
})(typeof window !== "undefined" ? window : this);
